var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeamlessDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#DED8CA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_315_1259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.22 25.59C31.3519 25.5882 32.46 25.9147 33.41 26.5301C34.0035 26.8989 34.4966 27.4086 34.8455 28.014C35.1945 28.6194 35.3884 29.3016 35.41 30V33C35.41 33.17 35.15 33.41 34.74 33.41H13.26C12.85 33.41 12.59 33.17 12.59 33V30C12.6098 29.3094 12.8035 28.6348 13.1531 28.0388C13.5027 27.4428 13.9969 26.9445 14.59 26.59C15.5341 25.9688 16.6398 25.6385 17.77 25.64H30.27M30.27 24.05H17.72C16.274 24.0454 14.8586 24.4662 13.65 25.26C12.8526 25.7713 12.1936 26.4714 11.7313 27.2982C11.2691 28.125 11.0179 29.053 11 30V33C11.036 33.5644 11.294 34.0915 11.7174 34.4662C12.1409 34.841 12.6955 35.0329 13.26 35H34.74C35.3045 35.0329 35.8591 34.841 36.2826 34.4662C36.706 34.0915 36.964 33.5644 37 33V30C36.981 29.0381 36.7235 28.096 36.2505 27.2582C35.7775 26.4204 35.1038 25.7132 34.29 25.2001C33.0793 24.4119 31.6646 23.9948 30.22 24L30.27 24.05Z",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 31H36",
    stroke: "#414143",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 35V37",
    stroke: "#414143",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12V26",
    stroke: "#414143",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 12V26",
    stroke: "#414143",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 35V37",
    stroke: "#414143",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 15.0001L27.37 13.0001C25.1718 12.3401 22.8282 12.3401 20.63 13.0001L14 15.0001",
    stroke: "#414143",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24.5V22.5C17.5 22.2348 17.6054 21.9804 17.7929 21.7929C17.9804 21.6054 18.2348 21.5 18.5 21.5H21.42C21.6852 21.5 21.9396 21.6054 22.1271 21.7929C22.3146 21.9804 22.42 22.2348 22.42 22.5V24.5",
    stroke: "#414143",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 24.5V22.5C25.5 22.2348 25.6054 21.9804 25.7929 21.7929C25.9804 21.6054 26.2348 21.5 26.5 21.5H29.42C29.6852 21.5 29.9396 21.6054 30.1271 21.7929C30.3146 21.9804 30.42 22.2348 30.42 22.5V24.5",
    stroke: "#414143",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_315_1259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeamlessDelivery);
export default __webpack_public_path__ + "static/media/seamless-delivery.da9e92003f75c6657755cd1f3ca5f6a9.svg";
export { ForwardRef as ReactComponent };